import React from "react";
import { useTable } from "react-table";

// bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

// custom components
import { Card } from "_atoms";
// styles
import { Colors, Spacing } from "_styles";

// tremor
import { Title as TremorTitle, Subtitle, Toggle, ToggleItem, Flex } from "@tremor/react";

//icons
import { FaCirclePlus } from "react-icons/fa6";
const TimelineAreaTable = ({
    columns,
    data,
    title,
    description,
    typeSwitch,
    setTypeSwitch,
    handleClick,
    handleOpenModal,
    handleViewAll,
}) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable({ columns, data });


    return (
        <Card>
            {/* heading */}
            <Row>
                <Col>
                    <Flex>
                        {/* title */}
                        <div>
                            <TremorTitle>{title}</TremorTitle>
                            <Subtitle>{description}</Subtitle>
                        </div>

                        <div>
                            {/* Departures / Arrivals / All Switcher */}
                            <Toggle
                                color="zinc"
                                defaultValue={typeSwitch?.[0] ?? "all"}
                                value={typeSwitch?.[0] ?? "all"}
                                onValueChange={(value) => setTypeSwitch(value)}
                            >
                                <ToggleItem value={"all"} text="All Zones" />
                                <ToggleItem value={"departures"} text="Departures" />
                                <ToggleItem value={"arrivals"} text="Arrivals" />
                            </Toggle>
                            {/* add timeline icon */}
                            <FaCirclePlus
                                onClick={handleOpenModal}
                                style={{ marginLeft: Spacing.SCALE_8, cursor: "pointer" }}
                                color={"lightgrey"}
                                size={28}
                            />
                        </div>
                    </Flex>
                </Col>
            </Row>

            {/* table contents */}
            {Array.isFullArray(data) ? (
                <table
                    {...getTableProps()}
                    style={{ width: "100%", marginLeft: 12, marginRight: 12 }}
                >
                    {/* column headers */}
                    <thead>
                        {headerGroups.map((headerGroup, headerGroupIndex) => (
                            <tr {...headerGroup.getHeaderGroupProps()}
                                key={headerGroupIndex}
                            >
                                {headerGroup.headers.map((column, headerIndex) => (
                                    <th
                                        style={{ borderBottomWidth: "1px", borderBottomColor: "#F2F2F2", borderBottomStyle: "solid", width: "25%" }}
                                        {...column.getHeaderProps()}
                                        key={headerIndex}
                                    >
                                        <div style={{ marginTop: 14 }}>
                                            {column.render("Header")}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    {/* body */}
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row);
                            return (
                                <>
                                    <tr key={i} {...row.getRowProps()} style={{ borderBottomWidth: "1px", borderTopWidth: "1px", borderBottomColor: "#F2F2F2", borderTopColor: "#F2F2F2", borderBottomStyle: "solid", height: 50, fontSize: 12, cursor: "pointer" }}>
                                        {row.cells.map((cell, cellIndex) => {
                                            return (
                                                <td
                                                    key={cellIndex}
                                                    style={{ padding: 12 }}
                                                    {...cell.getCellProps()}
                                                >
                                                    <div onClick={() => handleClick(i)} style={{ width: "80%" }} >
                                                        {cell.render("Cell")}
                                                    </div>

                                                </td>
                                            );
                                        })}
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            ) : (
                <Row style={{ opacity: 0.9 }} className="d-flex justify-content-center">
                    <p className="mt-3" style={{ textAlign: "center", color: Colors.PRM_LIGHT_BLUE }}>
                        {"No Time Zones Found ."}
                    </p>
                </Row>
            )}
        </Card>
    );
};

export default TimelineAreaTable;